import { Component, EventEmitter, inject, Input, OnInit, Output, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { ListService } from '../../services/list.service';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ButtonConfig } from '../../interfaces/list.interface';
import { FormsModule } from '@angular/forms';
import { ErrorAlertService } from '../../services/error-alert.service';
import { ModalComponent } from '../modal/modal.component';
import { HttpRequestService } from '../../services/http-request.service';
import { PopupDialogComponent } from '../popup-dialog/popup-dialog.component';
import { SharedDataService } from '../../services/shared-data-service';
import { STATIC_DATA } from '../../constants/static-data.constants';
import { NotificationService } from '../../services/notification.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { NgZorroModule } from '../../modules/ng-zorro/ng-zorro.module';
import { BaseComponent } from '../../utils/base.component';
import { FileTriageService } from '../../../services/fileTriage.service';
import { FileUploadNotificationService } from '../../../services/file-upload-notification.service';
import { FileUploadNotificationData } from '../../../interfaces/file-upload-notification.interface';
import { ClaimsService } from '../../../services/claims.service';
import { DialogConfig, DialogService } from '../../services/dialog.service';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { UserService } from '../../../services/user.service';
import { FocusTrapDirective } from '../../directives/focus-trap.directive';
import { DatePickerComponent } from '../date-picker/date-picker.component';
import { DropdownSelectComponent } from '../dropdown-select/dropdown-select.component';
import { MultiselectComponent } from '../multiselect/multiselect.component';

@Component({
  selector: 'ppl-actions',
  standalone: true,
  imports: [
    OverlayPanelModule,
    ButtonModule,
    FormsModule,
    PopupDialogComponent,
    NgZorroModule,
    NzDatePickerModule,
    FocusTrapDirective,
    DatePickerComponent,
    DropdownSelectComponent,
    MultiselectComponent
  ],
  templateUrl: './actions.component.html',
  styleUrl: './actions.component.css',
})
export class ActionsComponent extends BaseComponent implements OnInit {
  @Output() leadUpdated = new EventEmitter<boolean>();
  @Output() actionInvoked = new EventEmitter<boolean>();
  @Input() listButton: ButtonConfig[] = [];
  @Input() selectedCheckBoxValue: any[] = [];
  @Input() sourcePage = '';
  @Input() show: any;
  @Input() from = '';
  @ViewChild('payrollDialog') payrollDialog!: TemplateRef<any>;
  @ViewChild('menuDropdown', { read: ElementRef }) menuDropdown!: ElementRef<HTMLElement>;
  @ViewChild('actionTrigger', { read: ElementRef }) actionTrigger!: ElementRef<HTMLButtonElement>;
  actionActiveIndex = 0;
  private dialogSvc = inject(DialogService);
  comments = '';
  subject = '';
  approvalReasons: any[] = [];
  updateReasons: any[] = [];
  denialReasons: any[] = [];
  listOfSelectedValue: string[] = [];
  listOfSelectedValueStatus = '';
  selectedProgram = '';
  userList: any;
  programs: any[] = [];
  listOfOption: string[] = [];
  listOfOtherOptions: string[] = [];
  leadStatus: string[] = [];
  title = '';
  okText = '';
  isAssignToUser = false;
  placeholder = '';
  program: any;
  email: string[] = [];
  numbers: string[] = [];
  type = '';
  notificationType = '';
  labelForText = '';
  flow: any;
  showApproved = false;
  showButtons = true;
  noMessage = false;
  noSubject = false;
  placeholderStatus = '';
  disabledCheckDates: any;
  checkStartDate: Date | null | string = null;
  checkEndDate: Date | null | string = null;
  selectedDate!: Date | string;
  // showOkButton: boolean = false;
  /* alertDetails: any = {type: 'error', title: '', message: '', isVisible: false}; */

  isMenuShown = false;
  minDate: any;
  maxDate: any;

  constructor(
    private listService: ListService,
    private http: HttpRequestService,
    private sharedDataService: SharedDataService,
    private errorAlertService: ErrorAlertService,
    private notificationService: NotificationService,
    private fileTriageService: FileTriageService,
    private sharedService: SharedDataService,
    private fileUploadNotificationService: FileUploadNotificationService,
    private claimService: ClaimsService,
    private userService: UserService
  ) {
    super();
  }

  ngOnInit(): void {
    const program = this.userService.getSelectedProgram();
    if (program) {
      this.program = program.program_code;
    }
    this.listService.applicationDataSub.subscribe((data: any) => {
      if (this.from === 'details') {
        const mobileNumbers = data[0].mobile_number;
        this.email = data[0].email_id;
        this.numbers = mobileNumbers.map((number: string) => {
          if (!number.startsWith('+1')) {
            return '+1' + number;
          }
          return number;
        });
        this.numbers = mobileNumbers.map((number: string) => {
          const phoneNumber = number.replace(/-/g, '');
          if (!phoneNumber.startsWith('+1')) {
            return '+1' + phoneNumber;
          }
          return phoneNumber;
        });
      }
    });
    this.flow = this.sharedDataService.getType(this.sourcePage);
    /* this.errorAlertService.getAlertDetails().subscribe((details: any) => {
      this.alertDetails = details;
      console.log('Alert Details', details);

    }); */
  }
    focusActionTrigger() {
    if (this.actionTrigger && this.actionTrigger.nativeElement) {
      this.actionTrigger.nativeElement.focus();
    }
  }
    onTriggerKeydown(event: KeyboardEvent) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      this.isMenuShown = true;
      this.actionActiveIndex = event.key === 'ArrowDown' ? 0 : Math.max(0, (this.listButton?.length ?? 1) - 1);
      this.queueFocusActionOption();
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.isMenuShown = true;
      this.actionActiveIndex = 0;
      this.queueFocusActionOption();
    } else if (event.key === 'Escape' && this.isMenuShown) {
      event.preventDefault();
      this.isMenuShown = false;
      this.actionTrigger?.nativeElement.focus();
    }
  }
  onMenuVisibleChange(visible: boolean) {
    this.isMenuShown = visible;
    if (visible) {
      this.actionActiveIndex = 0;
      this.queueFocusActionOption();
    } else {
      this.actionActiveIndex = 0;
      this.resetMenuState(false);
    }
  }

  onActionMenuKeydown(e: KeyboardEvent) {
    e.stopPropagation();
    const len = this.listButton?.length ?? 0;
    if (!len) return;
    const max = len - 1;
    const go = (i: number) => {
      this.actionActiveIndex = i;
      this.queueFocusActionOption();
    };

    switch (e.key) {
      case 'ArrowDown': e.preventDefault(); go(this.actionActiveIndex >= max ? 0 : this.actionActiveIndex + 1); break;
      case 'ArrowUp':   e.preventDefault(); go(this.actionActiveIndex <= 0 ? max : this.actionActiveIndex - 1); break;

      // Prevent NVDA from switching to character nav mode
      case 'ArrowLeft':  e.preventDefault(); break;
      case 'ArrowRight': e.preventDefault(); break;

      case 'Home': e.preventDefault(); go(0); break;
      case 'End':  e.preventDefault(); go(max); break;

      case 'Tab': {
        e.preventDefault();
        if (e.shiftKey) {
          this.closeAndFocusPrev();
        } else {
          this.closeAndFocusNext();
        }
        break;
      }

      case 'Escape':
        e.preventDefault();
        this.isMenuShown = false;
        this.resetMenuState(true);
        this.actionTrigger?.nativeElement.focus();
        break;

      case 'Enter':
      case ' ':
      case 'Spacebar':
        e.preventDefault();
        this.activateActionOption();
        break;
    }
  }

  private resetMenuState(returnFocus = false) {
    this.actionActiveIndex = 0;
    this.isMenuShown = false;

    setTimeout(() => {
      this.menuDropdown?.nativeElement
        ?.querySelectorAll('.ant-menu-item-selected,[aria-selected="true"]')
        .forEach((el: Element) => {
          el.classList.remove('ant-menu-item-selected');
          (el as HTMLElement).setAttribute('aria-selected', 'false');
        });

      if (returnFocus) this.actionTrigger?.nativeElement?.focus();
    }, 0);
  }

  private queueFocusActionOption() {
    const id = `action-opt-${this.actionActiveIndex}`;
    let tries = 0;
    const tryFocus = () => {
      const el = document.getElementById(id) as HTMLElement | null;
      if (el) { el.focus(); return; }
      if (tries++ < 20) requestAnimationFrame(tryFocus);
    };
    setTimeout(() => requestAnimationFrame(tryFocus), 0);
    setTimeout(() => requestAnimationFrame(tryFocus), 30);
  }

  private focusActionOption() {
    const id = `action-opt-${this.actionActiveIndex}`;
    (document.getElementById(id) as HTMLElement | null)?.focus();
  }

  private activateActionOption() {
    const id = `action-opt-${this.actionActiveIndex}`;
    const li = document.getElementById(id);
    const btn = li?.querySelector('button') as HTMLButtonElement | null;
    this.isMenuShown = false;
    setTimeout(() => {
      if (btn) btn.click();
      else {
        const item = this.listButton?.[this.actionActiveIndex];
        if (item) this.actionClicked(item as any, new MouseEvent('click'));
      }
    }, 0);
  }

  private closeAndFocusNext() {
    this.resetMenuState(false);
    this.focusNextAfter(this.actionTrigger.nativeElement);
  }
  private closeAndFocusPrev() {
    this.resetMenuState(false);
    this.focusPrevBefore(this.actionTrigger.nativeElement);
  }

  private focusNextAfter(rootEl: HTMLElement) {
    const all = this.getFocusable();
    const current = document.activeElement as HTMLElement | null;
    const start = current ? all.indexOf(current) : all.indexOf(rootEl);
    const next = all[start + 1] || all[0];
    next?.focus();
  }
  private focusPrevBefore(rootEl: HTMLElement) {
    const all = this.getFocusable();
    const current = document.activeElement as HTMLElement | null;
    const start = current ? all.indexOf(current) : all.indexOf(rootEl);
    const prev = all[start - 1] || all[all.length - 1];
    prev?.focus();
  }
  private getFocusable(): HTMLElement[] {
    const sel = 'a[href],area[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    const nodes = Array.from(document.querySelectorAll<HTMLElement>(sel));
    return nodes.filter(el => {
      const s = getComputedStyle(el);
      return s.visibility !== 'hidden' && s.display !== 'none';
    });
  }

  updateAuth(program: any, status: string) {
    const payload = this.selectedCheckBoxValue.map((item) => ({
      authorizationId: item.authorizationId,
      statusLkp: status,
      decisionComments: this.comments,
      programCode: program.program_code,
    }));

    this.claimService
      .updateAuthStatus(program.program_code, payload)
      .subscribe((data) => {
        if (data.status == 200) {
          this.leadUpdated.emit(true);
          this.notificationService.alert(
            'success',
            'Success',
            `${status} successfully!`
          );
          this.handleCancel();
        }
      });
  }

  openPayrollDialog() {
    const dialogConfig: DialogConfig = {
      title: 'Payroll Processing',
      isOkText: 'Submit',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.payrollDialog,
      dialogConfig,
      () => this.handlePayrollOk(),
      () => this.handlePayrollCancel()
    );
  }

  handlePayrollOk() {
    const program = this.userService.getSelectedProgram();
    const programCode = program?.program_code;
    const tasTimesheetlineDetailIds = this.selectedCheckBoxValue.map(item => item.tasTimesheetlineDetailId);
    const payload = {
      checkDate: this.selectedDate,
      tasTimeSheetLineDetailIds: tasTimesheetlineDetailIds,
      programCode: programCode
    }
    this.claimService.submitPayrollProcessing(payload).subscribe((data: any) => {
      console.log('data submitted', data);
      this.leadUpdated.emit(true);
    })
  }

  handlePayrollCancel() {

  }

  handleOk(): void {
    const leadIds = this.selectedCheckBoxValue.map((item) => {
      if (this.flow === 'participant') {
        return item.lead_participant_id || item.leadId;
      } else if (this.flow === 'provider') {
        return item.lead_id || item.leadId;
      } else if (this.flow === 'referral') {
        return item.referral_participant_id || item.leadId;
      } else if (this.flow === 'participantenrlmnt') {
        return item.participant_id || item.leadId;
      } else if (this.flow === 'filetriage') {
        return item.filePath;
      } else if (this.flow === 'timesheet') {
        return item.timesheetLineId;
      } else {
        return item.provider_id || item.leadId;
      }
    });
    const selectedValues = Array.isArray(this.listOfSelectedValue)
      ? this.listOfSelectedValue
      : [this.listOfSelectedValue];
    const program = this.userService.getSelectedProgram();
    const programCode = program?.program_code;
    const commPayload: any = {
      message: this.comments,
      program: programCode,
      leadIds: leadIds.map((id) =>
        typeof id === 'number' ? id.toString() : id
      ),
      type: this.sharedDataService.getType(this.sourcePage),
    };
    switch (this.title) {
      case 'Assign to User': {
        const userMap = new Map<string, number>(
          this.userList.responsedata.map((user: any) => [
            `${user.first_name} ${user.last_name}`,
            user.userid,
          ])
        );
        const userIds = selectedValues
          .map((name: string) => userMap.get(name))
          .filter((id) => id !== undefined);
        const updatedPayload = {
          ids: leadIds,
          comments: this.comments,
          selectedUsers: userIds,
          type: this.sharedService.getType(this.sourcePage),
          programCode: programCode,
        };
        if (!userIds || userIds?.length < 1) {
          const errorMessage = 'Please select a user to complete this action.'
          this.errorAlertService.openModal('error', 'Error', errorMessage);
        }
        else {
          this.listService.assignUser(updatedPayload).subscribe((data: any) => {
            if (data.status == 200) {
              this.leadUpdated.emit(true);
              this.notificationService.alert(
                'success',
                'Success',
                'Assigned to user successfully!'
              );
              this.handleCancel();
            }
          });
        }
        break;
      }

      case 'Assign to me': {
        const user = this.userService.getUserDetails();
        const userId = user?.userid;
        const updatedPayload = {
          ids: leadIds,
          comments: this.comments,
          selectedUsers: [userId],
          type: this.sharedService.getType(this.sourcePage),
          programCode: programCode,
        };
        this.listService.assignUser(updatedPayload).subscribe((data: any) => {
          if (data.status == 200) {
            this.leadUpdated.emit(true);
            this.notificationService.alert(
              'success',
              'Success',
              'Assigned to you successfully!'
            );
            this.handleCancel();
          }
        });
        break;
      }

      case 'Review Complete': {
        const program = this.userService.getSelectedProgram();
        const type = this.sharedDataService.getType(this.sourcePage);
        const flowTypes = ['referral'];
        const selectedProgram = flowTypes.includes(this.flow)
          ? program?.program_code
          : this.selectedProgram;
        const reason = this.getLookupName(
          this.approvalReasons,
          selectedValues[0]
        );

        const updatedPayload = {
          ...(type === 'referral'
            ? { referralIds: leadIds }
            : type === 'participantenrlmnt'
              ? { participantIds: leadIds }
              : type === 'providerenrlmnt'
                ? { providerIds: leadIds }
                : { leadIds }),
          comments: this.comments,
          programCode: selectedProgram,
          status: 'RC',
          reasonCode: reason,
        };
        this.listService
          .updateUserStatus(
            updatedPayload,
            this.sharedDataService.getType(this.sourcePage)
          )
          .subscribe((data) => {
            if (data.status == 200) {
              this.leadUpdated.emit(true);
              this.notificationService.alert(
                'success',
                'Success',
                'Review Completed successfully!'
              );
              this.handleCancel();
            }
          });
        break;
      }

      case 'Approve': {
        const program = this.userService.getSelectedProgram();
        if (this.sourcePage.includes('authorizations')) {
          this.updateAuth(program, 'Approved');
          return;
        }
        const type = this.sharedDataService.getType(this.sourcePage);
        const flowTypes = ['referral', 'participantenrlmnt', 'providerenrlmnt'];
        const selectedProgram = flowTypes.includes(this.flow)
          ? program?.program_code
          : this.selectedProgram;
        const reason = this.getLookupName(
          this.approvalReasons,
          selectedValues[0]
        );
        if (this.flow === 'participant' || this.flow === 'provider') {
          let errorMessage = '';
          if (!selectedProgram && !reason) {
            errorMessage =
              'Please select both Program and Reason to complete this action.';
          } else if (!selectedProgram && reason) {
            errorMessage = 'Please select a Program to complete this action.';
          } else if (selectedProgram && !reason) {
            errorMessage = 'Please select a Reason to complete this action.';
          }
          if (errorMessage) {
            this.errorAlertService.openModal('error', 'Error', errorMessage);
            break;
          }
        }

        const updatedPayload = {
          ...(type === 'referral'
            ? { referralIds: leadIds }
            : type === 'participantenrlmnt'
              ? { participantIds: leadIds }
              : type === 'providerenrlmnt'
                ? { providerIds: leadIds }
                : { leadIds }),
          comments: this.comments,
          programCode: selectedProgram,
          status: 'APPROVE',
          reasonCode: reason,
        };
        this.listService
          .updateUserStatus(
            updatedPayload,
            this.sharedDataService.getType(this.sourcePage)
          )
          .subscribe((data) => {
            if (data.status == 200) {
              this.leadUpdated.emit(true);
              this.notificationService.alert(
                'success',
                'Success',
                'Approved successfully!'
              );
              this.handleCancel();
            }
          });
        break;
      }

      case 'Deny': {
        const type = this.sharedDataService.getType(this.sourcePage);
        if (this.sourcePage.includes('authorizations')) {
          this.updateAuth(program, 'Rejected');
          return;
        }
        const updatedPayload = {
          ...(type === 'referral'
            ? { referralIds: leadIds }
            : type === 'participantenrlmnt'
              ? { participantIds: leadIds }
              : type === 'providerenrlmnt'
                ? { providerIds: leadIds }
                : { leadIds }),
          comments: this.comments,
          programCode: programCode,
          status: 'REJECT',
          reasonCode: this.getLookupName(this.denialReasons, selectedValues[0]),
        };
        this.listService
          .updateUserStatus(
            updatedPayload,
            this.sharedDataService.getType(this.sourcePage)
          )
          .subscribe((data) => {
            if (data.status == 200) {
              this.leadUpdated.emit(true);
              this.notificationService.alert(
                'success',
                'Success',
                'Denied successfully!'
              );
              this.handleCancel();
            }
          });
        break;
      }
      case 'Resurrect': {
        const type = this.sharedDataService.getType(this.sourcePage);
        const updatedPayload = {
          ...(type === 'referral'
            ? { referralIds: leadIds }
            : type === 'participantenrlmnt'
              ? { participantIds: leadIds }
              : type === 'providerenrlmnt'
                ? { providerIds: leadIds }
                : { leadIds }),
          comments: this.comments,
          programCode: programCode,
          status: 'RESURRECT',
          reasonCode: this.getLookupName(
            this.approvalReasons,
            selectedValues[0]
          ),
        };
        this.listService
          .updateUserStatus(
            updatedPayload,
            this.sharedDataService.getType(this.sourcePage)
          )
          .subscribe((data) => {
            if (data.status == 200) {
              this.leadUpdated.emit(true);
              this.notificationService.alert(
                'success',
                'Success',
                'Resurrected successfully!'
              );
              this.handleCancel();
            }
          });
        break;
      }
      case 'Send SMS': {
        const payload: any = {
          ...commPayload,
          communicationType: 'SMS',
          ...(this.from === 'details' ? { recipients: this.numbers } : {}),
        };
        if (this.comments.trim() == '') {
          this.noMessage = true;
        } else {
          this.noMessage = false;
          this.listService
            .sendNotification(this.from, payload)
            .subscribe((data) => {
              if (data.status == 200) {
                this.notificationService.alert(
                  'success',
                  'Success',
                  'SMS sent successfully!'
                );
              }
              this.handleCancel();
            });
        }
        break;
      }
      case 'Send Email': {
        const payload: any = {
          ...commPayload,
          communicationType: 'EMAIL',
          subject: this.subject,
          ...(this.from === 'details' ? { recipients: this.email } : {}),
        };
        if (this.subject.trim() == '') {
          this.noSubject = true;
        } else {
          this.noSubject = false;
        }
        if (this.comments.trim() == '') {
          this.noMessage = true;
        } else {
          this.noMessage = false;
        }

        if (!this.noSubject && !this.noMessage) {
          this.listService
            .sendNotification(this.from, payload)
            .subscribe((data) => {
              if (data.status == 200) {
                this.notificationService.alert(
                  'success',
                  'Success',
                  'Email sent successfully!'
                );
              }
              this.handleCancel();
            });
        }
        break;
      }
      case 'Update Status': {
        const program = this.userService.getSelectedProgram();
        const type = this.sharedDataService.getType(this.sourcePage);
        const flowTypes = ['referral', 'participantenrlmnt', 'providerenrlmnt'];
        const updatedPayload = {
          participantIds: leadIds,
          comments: this.comments,
          programCode: flowTypes.includes(this.flow)
            ? program?.program_code
            : this.selectedProgram,
          status: this.listOfSelectedValueStatus
            .toUpperCase()
            .replace(/\s/g, '_'),
          reasonCode: this.getLookupName(
            this.approvalReasons,
            selectedValues[0]
          ),
        };
        // if(this.okText == 'Ok'){
        //   this.handleCancel();
        // }
        // else{
        this.listService
          .updateParticipantStatus(updatedPayload, true)
          .subscribe((data) => {
            if (data.status == 200) {
              this.listOfSelectedValueStatus = '';
              this.notificationService.alert(
                'success',
                'Success',
                'Status Updated successfully!'
              );
              this.leadUpdated.emit(true);
              // this.listOfSelectedValue = [];
              // this.comments = '';
              // this.selectedProgram = '';
              this.handleCancel();
            }
          });
        // }
        break;
      }
    }
  }

  getLookupName(lookupArr: any[], valueName: string): string | undefined {
    const lookup = lookupArr.find((gen) => {
      return gen.lkpValueName === valueName;
    });
    return lookup ? lookup.lkpValueCode : undefined;
  }

  handleCancel(): void {
    this.listOfSelectedValue = [];
    this.show = false;
    this.showApproved = false;
    this.showButtons = true;
    this.comments = '';
    this.selectedProgram = '';
    this.noMessage = false;
    this.listOfSelectedValueStatus = '';
    this.type = '';
    this.title = '';
    // this.showOkButton = false;
  }

  disableDates = (current: Date): boolean => {
    const formattedCurrentDate = this.formatDateWithoutTime(current.toISOString());

    const disableBefore = this.checkStartDate ? formattedCurrentDate < this.checkStartDate : false;
    const disableAfter = this.checkEndDate ? formattedCurrentDate > this.checkEndDate : false;

    return disableBefore || disableAfter;
  };
  formatDateWithoutTime(dateStr: string): string {
    const date = new Date(dateStr);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);  // Get month (0-based, so add 1)
    const day = ('0' + date.getDate()).slice(-2);  // Get day
    const year = date.getFullYear();  // Get year
    return `${month}/${day}/${year}`;
  }

  actionClicked(btn: ButtonConfig, event: Event) {
    event.stopPropagation();
    this.resetMenuState(true);
    if (this.sourcePage == 'pendedTimesheet') {
      if (btn.buttonAction == 'denyTimesheet' || btn.buttonAction == 'overrideTimesheet' || btn.buttonAction == 'submitForProcessing' || btn.buttonAction == 'assignToUser') {
        if (!this.selectedCheckBoxValue?.length) {
          const errorMessage = 'Please select records for completing this action.';
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          return;
        }
      }

      this.actionInvoked.emit({ button: btn, selectedCheckBox: this.selectedCheckBoxValue } as any);
      return;
    }

    if (!this.selectedCheckBoxValue?.length) {
      const errorMessage = 'Please select records for completing this action.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    this.leadStatus = this.selectedCheckBoxValue.map(
      (item) => item.application_status_lkp || item.statusLkp
    );
    const selectedEmails = this.selectedCheckBoxValue.map(
      (item) => item.email
    );
    const selectedMobile = this.selectedCheckBoxValue.map(
      (item) => item.mobile
    );

    const setupModal = (
      title: string,
      okText: string,
      placeholder: string,
      isAssignToUser: boolean
    ) => {
      this.show = true;
      this.title = title;
      this.okText = okText;
      this.isAssignToUser = isAssignToUser;
      this.placeholder = placeholder;
    };

    this.labelForText = 'Comments: ';
    const recordType = this.sourcePage.includes('authorizations')
      ? 'authorizations'
      : 'applications';
    switch (btn.buttonAction) {
      case 'assign_to_user': {
        if (
          this.leadStatus.some(
            (status: string) =>
              status == 'Approved' ||
              (this.flow === 'referral' && status == 'Review Complete') ||
              status == 'Denied' ||
              status == 'Disenrolled'
          )
        ) {
          const errorMessage = `Please deselect the Approved${this.flow === 'referral' ? ', Review Complete,' : ''} and Denied ${recordType} to continue with this action.`;
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          break;
        }

        const userDetails = this.userService.getUserDetails();
        const userType = userDetails?.usertype_lkp?.toUpperCase();
        const belongsto_org = userDetails?.belongsto_org;
        const payload = {
          lookupValue: [{ lkpValueCode: userType, lkpValueName: 't', belongsToOrg: belongsto_org }],
        };
        this.listService.getUsers(payload).subscribe((data: any) => {
          this.userList = data;
          this.listOfOption = data.responsedata.map(
            (user: any) => `${user.first_name} ${user.last_name}`
          );
        });
        setupModal('Assign to User', 'Assign', 'Please select User', true);
        break;
      }

      case 'assign_to_me':
        if (
          this.leadStatus.some(
            (status: string) =>
              status == 'Approved' ||
              (this.flow === 'referral' && status == 'Review Complete') ||
              status == 'Denied' ||
              status == 'Disenrolled'
          )
        ) {
          const errorMessage = `Please deselect the Approved${this.flow === 'referral' ? ', Review Complete,' : ''} and Denied ${recordType} to continue with this action.`;
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          break;
        }
        setupModal('Assign to me', 'Assign', 'Please select Reason', false);
        break;

      case 'submit_for_processing':
        this.claimService.getCheckDates().subscribe((dates: any) => {
          console.log('check dates##################', dates.responsedata);
          this.checkStartDate = dates?.responsedata?.earliestImportCheckDate ? this.formatDateWithoutTime(dates?.responsedata?.earliestImportCheckDate) : null;
          this.checkEndDate = dates?.responsedata?.latestImportCheckDate ? this.formatDateWithoutTime(dates?.responsedata?.latestImportCheckDate) : null;
          this.minDate = this.checkStartDate ? new Date(this.checkStartDate) : null;
          this.maxDate = this.checkEndDate ? new Date(this.checkEndDate) : null;
          this.openPayrollDialog();
        })

        break;

      case 'approve':
        if (this.flow === 'participant' || this.flow === 'provider') {
          this.listService.getPrograms().subscribe((data: any) => {
            if (data.responsedata) {
              this.programs = data.responsedata.filter(
                (program: any) => program?.program_code !== STATIC_DATA.LEAD_PROGRAM
              );
            }
          });
        }

        if (
          this.leadStatus.some(
            (status: string) =>
              status == 'Approved' ||
              (this.flow === 'referral' && status == 'Review Complete') ||
              status == 'Denied' ||
              status == 'Disenrolled' ||
              status == 'Rejected'
          )
        ) {
          const errorMessage = `Please deselect the Approved${this.flow === 'referral' ? ', Review Complete,' : ''} and Denied ${recordType} to continue with this action.`;
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          break;
        }
        if (this.leadStatus.some((status: string) => status == null)) {
          const errorMessage =
            'Please deselect the unsubmitted application to continue with this action';
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          break;
        }
        this.approvalReasons = this.lookupService.getLookupValue(
          'Lead_Reason_for_Approval'
        );
        this.listOfOption = this.approvalReasons.map(
          (item) => item.lkpValueName
        );
        setupModal('Approve', 'Approve', 'Please select Reason', false);
        break;

        case 'review_complete':
          if (this.flow === 'referral') {
            this.listService.getPrograms().subscribe((data: any) => {
              if (data.responsedata) {
                this.programs = data.responsedata.filter(
                  (program: any) => program?.program_code !== STATIC_DATA.LEAD_PROGRAM
                );
              }
            });
          }

          this.approvalReasons = this.lookupService.getLookupValue(
            'Lead_Reason_for_Approval'
          );
          this.listOfOption = this.approvalReasons.map(
            (item) => item.lkpValueName
          );
          setupModal('Review Complete', 'Review Complete', 'Please select Reason', false);
          break;

      case 'Deny':
        if (
          this.leadStatus.some(
            (status: string) =>
              status == 'Approved' ||
              (this.flow === 'referral' && status == 'Review Complete') ||
              status == 'Denied' ||
              status == 'Disenrolled' ||
              status == 'Rejected'
          )
        ) {
          const errorMessage = `Please deselect the Approved${this.flow === 'referral' ? ', Review Complete,' : ''} and Denied ${recordType} to continue with this action.`;
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          break;
        }
        this.denialReasons = this.lookupService.getLookupValue(
          'Lead_Reason_for_Denial'
        );
        this.listOfOption = this.denialReasons.map((item) => item.lkpValueName);
        setupModal('Deny', 'Deny', 'Please select Reason', false);
        break;

      case 'Resurrect':
        if (
          this.leadStatus.some(
            (status: string) => status !== 'Denied' && status !== 'Disenrolled'
          )
        ) {
          const errorMessage = `Only denied ${recordType} can be resurrected.`;
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          break;
        }
        this.approvalReasons = this.lookupService.getLookupValue(
          'Lead_Reason_for_Approval'
        );
        this.listOfOption = this.approvalReasons.map(
          (item) => item.lkpValueName
        );
        setupModal('Resurrect', 'Resurrect', 'Please select Reason', false);
        break;
      case 'sendSMS':
        if (this.from !== 'details' &&
          selectedMobile.some(
            (mobile: string) =>
              mobile == null
          )
        ) {
          const errorMessage = `Please add a mobile number for each of the ${recordType} to proceed with this action.`;
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          break;
        }
        if (this.from === 'details' && this.numbers.length === 0) {
          this.notificationService.alert(
            'error',
            'Error',
            'Please add mobile number.'
          );
        } else {
          this.labelForText = 'Message: ';
          this.type = 'SMS';
          this.notificationType = 'mobile number';
          setupModal('Send SMS', 'Send', 'Please type here...', false);
        }
        break;
      case 'sendEmail':
        if (this.from !== 'details' &&
          selectedEmails.some(
            (mobile: string) =>
              mobile == null
          )
        ) {
          const errorMessage = `Please add an email for each of the ${recordType} to proceed with this action.`;
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          break;
        }
        if (this.from === 'details' && !this.email) {
          this.notificationService.alert(
            'error',
            'Error',
            'Please add email address.'
          );
        } else {
          this.labelForText = 'Message: ';
          this.type = 'Email';
          this.notificationType = 'email address';
          setupModal('Send Email', 'Send', 'Please type here...', false);
        }
        break;
      case 'fileTriageAssign':
        this.fileTriageService.callOpenDialogFunction(
          this.selectedCheckBoxValue
        );
        break;
      case 'fileUploadNotificationAcknowledge':
        this.fileUploadNotificationService
          .acknowledgeFiles(
            this.selectedCheckBoxValue as FileUploadNotificationData[],
            this.program
          )
          .subscribe((res) => {
            if (res.status === 200) {
              this.notificationService.alert(
                'success',
                'Success',
                `Successfully acknowledged ${res?.responsedata?.acknowledgments?.length} file(s).`
              );
            } else {
              this.notificationService.alert(
                'error',
                'Error',
                'Error acknowledging file(s).'
              );
            }
            this.leadUpdated.emit(true);
          });
        break;
      case 'update_status':
        if (
          this.leadStatus.some(
            (status: string) =>
              status == 'Approved' ||
              (this.flow === 'referral' && status == 'Review Complete') ||
              status == 'Denied' ||
              status == 'Disenrolled'
          )
        ) {
          const errorMessage = `Please deselect the Approved${this.flow === 'referral' ? ', Review Complete,' : ''} and Denied ${recordType} to continue with this action.`;
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          break;
        }
        this.approvalReasons = this.lookupService.getLookupValue(
          'Lead_Reason_for_Approval'
        );
        this.updateReasons = this.lookupService.getLookupValue(
          'Participant_Enrollment_status'
        );
        this.listOfOption = this.approvalReasons.map(
          (item) => item.lkpValueName
        );
        this.listOfOtherOptions = this.updateReasons.map(
          (item) => item.lkpValueName
        );
        this.placeholderStatus = 'Please select status';
        setupModal('Update Status', 'Update', 'Please select Reason', false);
        break;
      case 'send_registration':
        if (
          this.flow === 'participantenrlmnt' &&
          this.leadStatus.some(
            (status: string) =>
              status == 'In Progress' || status == 'New Application'
          )
        ) {
          const errorMessage = `Please deselect New and In Progress ${recordType} to continue with this action.`;
          this.errorAlertService.openModal('error', 'Error', errorMessage);
          break;
        }
        {
          const leadIds = this.selectedCheckBoxValue.map((item) => {
            if (this.flow === 'participant') {
              return item.lead_participant_id || item.leadId;
            } else if (this.flow === 'provider') {
              return item.lead_id || item.leadId;
            } else if (this.flow === 'referral') {
              return item.referral_participant_id || item.leadId;
            } else if (this.flow === 'participantenrlmnt') {
              return item.participant_id || item.leadId;
            } else {
              return item.provider_id || item.leadId;
            }
          });
          let pageType = '';
          if (this.from === 'details' && this.flow === 'participantenrlmnt') {
            pageType = 'participantDetail';
          } else if (
            this.from !== 'details' &&
            this.flow === 'participantenrlmnt'
          ) {
            pageType = 'participantList';
          } else if (
            this.from === 'details' &&
            this.flow === 'providerenrlmnt'
          ) {
            pageType = 'providerDetail';
          } else if (
            this.from !== 'details' &&
            this.flow === 'providerenrlmnt'
          ) {
            pageType = 'providerList';
          }
          const program = this.userService.getSelectedProgram();
          const flowTypes = [
            'referral',
            'participantenrlmnt',
            'providerenrlmnt',
          ];
          let updatedPayload: any;
          if (this.flow === 'participantenrlmnt') {
            updatedPayload = {
              participantIds: leadIds,
              comments: this.comments,
              pageType: pageType,
              commType: 'Registration',
              programCode: flowTypes.includes(this.flow)
                ? program?.program_code
                : this.selectedProgram,
            };
          } else if (this.flow === 'providerenrlmnt') {
            updatedPayload = {
              providerIds: leadIds,
              programCode: flowTypes.includes(this.flow)
                ? program?.program_code
                : this.selectedProgram,
            };
          }
          this.listService
            .sendRegistrationLink(updatedPayload, this.flow)
            .subscribe((data: any) => {
              if (data.status == 200) {
                this.notificationService.alert(
                  'success',
                  'Success',
                  'Registration Link resent successfully!'
                );
                this.leadUpdated.emit(true);
                this.handleCancel();
              }
            });
          break;
        }
    }
  }
}
